













































import { Ref, Prop, Component, Vue, Inject } from 'vue-property-decorator'
import { cloneDeep, isEqual } from 'lodash'
import { User } from '@/api/model/user'
import { UserAPI } from '@/api/backend-client'
import { UserTarget } from '@/api/model/user-target'
import { CompanyTargetType } from '@/api/types'
import ListTargets from '@/views/Company/Settings/Users/Edit/ListTargets.vue'
import CreateTarget from '@/views/Company/Settings/Users/Edit/CreateTarget.vue'
import EditTarget from '@/views/Company/Settings/Users/Edit/EditTarget.vue'

@Component({
    components: {ListTargets, CreateTarget, EditTarget},
})
export default class CompanySettingsUsersEdit extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    @Prop({ required: true }) readonly userId!: string
    user: User = null
    editingUser: User = null
    loading: boolean = false
    saving: boolean = false
    @Ref() listTargets: ListTargets
    creatingTarget: boolean = false
    editingTarget: UserTarget = null

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.user = await UserAPI.get(this.userId)
        this.editingUser = cloneDeep(this.user)
        this.loading = false
    }

    async save(): Promise<void> {
        this.editingUser.dashboardPermissions = this.editingUser.dashboardPermissions.filter(dashboardPermission => {
            if (dashboardPermission.permission !== null) {
                return true
            }

            if (dashboardPermission.powerBiCustomRole !== null) {
                return true
            }

            return false
        })

        this.saving = true

        this.user = await UserAPI.update(this.userId, {
            ...this.editingUser,
            company: this.$currentCompany,
        } as User)
        this.editingUser = cloneDeep(this.user)

        this.saving = false
        await this.$router.push({ name: 'company_settings_users_list' })

        // values arent properly updated after an update on the edit screen
        window.location.reload()
    }

    async cancel(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_users_list',
        })
    }

    get hasChanges(): boolean {
        return isEqual(this.user, this.editingUser) === false
    }

    get hasUserTargets(): boolean {
        return this.$currentCompany.targetType === CompanyTargetType.USER
    }

    onTargetCreate(): void {
        this.creatingTarget = true
    }

    async onTargetCreated(): Promise<void> {
        this.creatingTarget = false
        await this.listTargets.reloadTargets()
    }

    onTargetEdit(target: UserTarget): void {
        this.editingTarget = target
    }

    async onTargetUpdated(): Promise<void> {
        this.editingTarget = null
        await this.listTargets.reloadTargets()
    }

    onTargetCancel(): void {
        this.creatingTarget = false
        this.editingTarget = null
    }
}
